import CustomIcon from '@/components/CustomIcon';

// 处理页面菜单
export function processMenuItems(menuList: any[]): any[] {
  return menuList.map((item: any) => {
    // 处理当前菜单项
    const processedItem = {
      path: item.path,
      name: item.name,
      icon: CustomIcon({ name: item.icon, styles: { fontSize: '20px' } }),
    };

    // 如果当前菜单项有 children，递归处理 children
    if (item.children && item.children.length > 0) {
      processedItem.children = processMenuItems(item.children);
    }

    // 如果当前菜单项有 routes，递归处理 routes
    if (item.routes && item.routes.length > 0) {
      processedItem.routes = processMenuItems(item.routes);
    }

    return processedItem;
  });
}


// 获取文件格式
export function fileFormat(name: any) {
  let format = ''
  if (name) {
    const index = name.lastIndexOf('.')
    format = name.substring(index + 1, name.length)
  }

  return format
}

/**
 * 获取当前时间和指定地点的字符串。
 * 时间格式为 "YYYY年MM月DD日 HH:mm"。
 * 
 * @returns {string} 返回时间和位置的字符串。
 */ 
export function getCurrentTimeAndLocation() {
  try {
    // 创建一个新的Date对象
    const now = new Date();

    // 设置时间显示选项
    const options = {
      year: 'numeric',  // 完整年份
      month: '2-digit', // 两位数字的月份
      day: '2-digit',   // 两位数字的日期
      hour: '2-digit',  // 两位数字的小时
      minute: '2-digit', // 两位数字的分钟
      hour12: false    // 使用24小时制
    };

    // 使用Intl.DateTimeFormat来格式化日期和时间
    const formattedDateTime = new Intl.DateTimeFormat('zh-CN', options).format(now);
    
    // 定义位置
    const location = "上海";

    // 将格式化的日期时间和地点组合成一个字符串返回
    return `${formattedDateTime.replace(/\//g, '年').replace(/\//g, '月').replace(',', '日')} ${location}`;
  } catch (error) {
    // 错误处理，可以根据具体要求进行调整
    console.error("Error in generating date-time location string: ", error);
    throw new Error("无法生成日期时间地点字符串");
  }
}